const GET_INSPECTION_ORDER_LIST = 'GET_INSPECTION_ORDER_LIST'
const GET_INSPECTION_ORDER_LIST_SUCCESS = 'GET_INSPECTION_ORDER_LIST_SUCCESS'

const GET_INSPECTION_RTW_ORDER_LIST = 'GET_INSPECTION_RTW_ORDER_LIST'
const GET_INSPECTION_RTW_ORDER_LIST_SUCCESS = 'GET_INSPECTION_RTW_ORDER_LIST_SUCCESS'

const GET_INSPECTION_DETAIL_ORDER = 'GET_INSPECTION_DETAIL_ORDER'
const GET_INSPECTION_DETAIL_ORDER_SUCCESS = 'GET_INSPECTION_DETAIL_ORDER_SUCCESS'

const GET_INSPECTION_DETAIL_RTW_ORDER = 'GET_INSPECTION_DETAIL_RTW_ORDER'
const GET_INSPECTION_DETAIL_RTW_ORDER_SUCCESS = 'GET_INSPECTION_DETAIL_RTW_ORDER_SUCCESS'

const GET_INSPECTION_DETAIL_ORDER_SIZE = 'GET_INSPECTION_DETAIL_ORDER_SIZE'
const GET_INSPECTION_DETAIL_ORDER_SIZE_SUCCESS = 'GET_INSPECTION_DETAIL_ORDER_SIZE_SUCCESS'

const GET_INSPECTION_DETAIL_RTW_ORDER_SIZE = 'GET_INSPECTION_DETAIL_RTW_ORDER_SIZE'
const GET_INSPECTION_DETAIL_RTW_ORDER_SIZE_SUCCESS = 'GET_INSPECTION_DETAIL_RTW_ORDER_SIZE_SUCCESS'

const POST_ORDER = 'POST_ORDER'
const POST_ORDER_SUCCESS = 'POST_ORDER_SUCCESS'

const POST_RTW_ORDER = 'POST_RTW_ORDER'
const POST_RTW_ORDER_SUCCESS = 'POST_RTW_ORDER_SUCCESS'

const PATCH_DEFECT = 'PATCH_DEFECT'
const PATCH_DEFECT_SUCCESS = 'PATCH_DEFECT_SUCCESS'

const POST_ORDER_MEMO = 'POST_ORDER_MEMO'
const POST_ORDER_MEMO_SUCCESS = 'POST_ORDER_MEMO_SUCCESS'

const POST_RTW_ORDER_MEMO = 'POST_RTW_ORDER_MEMO'
const POST_RTW_ORDER_MEMO_SUCCESS = 'POST_RTW_ORDER_MEMO_SUCCESS'

const InspectionType = {
  GET_INSPECTION_ORDER_LIST,
  GET_INSPECTION_ORDER_LIST_SUCCESS,

  GET_INSPECTION_RTW_ORDER_LIST,
  GET_INSPECTION_RTW_ORDER_LIST_SUCCESS,

  GET_INSPECTION_DETAIL_ORDER,
  GET_INSPECTION_DETAIL_ORDER_SUCCESS,

  GET_INSPECTION_DETAIL_RTW_ORDER,
  GET_INSPECTION_DETAIL_RTW_ORDER_SUCCESS,

  GET_INSPECTION_DETAIL_ORDER_SIZE,
  GET_INSPECTION_DETAIL_ORDER_SIZE_SUCCESS,

  GET_INSPECTION_DETAIL_RTW_ORDER_SIZE,
  GET_INSPECTION_DETAIL_RTW_ORDER_SIZE_SUCCESS,

  POST_ORDER,
  POST_ORDER_SUCCESS,

  POST_RTW_ORDER,
  POST_RTW_ORDER_SUCCESS,

  PATCH_DEFECT,
  PATCH_DEFECT_SUCCESS,

  POST_ORDER_MEMO,
  POST_ORDER_MEMO_SUCCESS,

  POST_RTW_ORDER_MEMO,
  POST_RTW_ORDER_MEMO_SUCCESS

}

export default InspectionType
